var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoritIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.73223 2.64966L11.4021 6.00537C11.5251 6.24849 11.7599 6.41733 12.0307 6.45485L15.7815 7.00113C16.0006 7.03189 16.1994 7.14745 16.3336 7.32379C16.4664 7.49788 16.5234 7.71849 16.4912 7.93535C16.4649 8.11544 16.3802 8.28203 16.2504 8.40959L13.5325 11.0442C13.3337 11.228 13.2437 11.5004 13.2917 11.7668L13.9609 15.4707C14.0321 15.9179 13.7358 16.3396 13.2917 16.4244C13.1087 16.4537 12.9212 16.4229 12.7561 16.3389L9.41041 14.5957C9.1621 14.4704 8.86879 14.4704 8.62049 14.5957L5.27477 16.3389C4.86368 16.5572 4.35432 16.4087 4.12552 16.0035C4.04075 15.8421 4.01075 15.6583 4.0385 15.4789L4.70765 11.7743C4.75566 11.5087 4.66489 11.2348 4.46685 11.0509L1.74901 8.41785C1.42569 8.10569 1.41594 7.59168 1.72726 7.26826C1.73401 7.26151 1.74151 7.254 1.74901 7.2465C1.87804 7.11518 2.04758 7.03189 2.23062 7.01013L5.98142 6.4631C6.25148 6.42483 6.48628 6.2575 6.61006 6.01287L8.2199 2.64966C8.36318 2.36152 8.66025 2.18218 8.98282 2.18968H9.08334C9.36315 2.22345 9.60695 2.39679 9.73223 2.64966Z",
    fill: "url(#paint0_linear_3893_2703)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99401 14.5023C8.84873 14.5068 8.7072 14.5458 8.5799 14.6156L5.25054 16.3548C4.84317 16.5492 4.35567 16.3983 4.12728 16.0088C4.04266 15.8496 4.01195 15.6672 4.04041 15.4886L4.70538 11.7918C4.75031 11.5231 4.66045 11.2499 4.465 11.0607L1.74595 8.42831C1.4232 8.1123 1.41721 7.59363 1.73322 7.27011C1.73772 7.26561 1.74146 7.26185 1.74595 7.2581C1.87475 7.1305 2.041 7.04643 2.21997 7.02016L5.97392 6.4677C6.24575 6.43317 6.48164 6.26354 6.60145 6.01733L8.23318 2.61179C8.3882 2.33707 8.68549 2.17343 9 2.1907C8.99401 2.41363 8.99401 14.3507 8.99401 14.5023Z",
    fill: "url(#paint1_linear_3893_2703)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3893_2703",
    x1: 0.413044,
    y1: -1.4668,
    x2: 11.7452,
    y2: 20.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3893_2703",
    x1: 0.956522,
    y1: -1.4668,
    x2: 15.0471,
    y2: 12.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritIcon);
export default __webpack_public_path__ + "static/media/FavoritIcon.109533c936fce918c68f4365614e0ea4.svg";
export { ForwardRef as ReactComponent };